// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"244":"naija","251":"recipes","443":"about","578":"singles","904":"accom","907":"places"}[chunkId] + "." + {"244":"05bf2b27","251":"36496d41","443":"b0bb29e4","578":"013206c1","904":"c5027555","907":"17a53c8f"}[chunkId] + ".js";
};